import { AxiosError } from "axios";
import customAxios from "config";
import { renterError } from "utils/errorMessage";

export type ResolveResult =
  | { kind: "ok"; targetUrl: string }
  | { kind: "expired" }
  | { kind: "not_found" }
  | { kind: "error"; message: string };

// Looks up a payment short-link slug on Django. The backend identifies the
// tenant from the request's Host header (which is the rental company's
// custom domain) — no extra context needed from the client.
export const resolveShortLink = async (
  slug: string
): Promise<ResolveResult> => {
  try {
    const response = await customAxios.get("/api/short-links/resolve/", {
      params: { slug },
    });
    const target = response?.data?.target_url;
    if (typeof target === "string" && target.length > 0) {
      return { kind: "ok", targetUrl: target };
    }
    // `message` is rendered verbatim to the renter on the redirect page, so
    // these read as copy, not as diagnostics ("Empty target URL", "Network
    // error" were both on screen).
    return {
      kind: "error",
      message:
        "This payment link is no longer valid. Please contact the rental company.",
    };
  } catch (error) {
    if (error instanceof AxiosError && error.response) {
      if (error.response.status === 410) {
        return { kind: "expired" };
      }
      if (error.response.status === 404) {
        return { kind: "not_found" };
      }
    }
    return { kind: "error", message: renterError(error, "payment") };
  }
};
